import * as Html from "../util/Html.ts";
import * as amplify from "../util/amplify.ts";
import * as websocket from "../util/websocket.ts";

  var
    datas = {};

  amplify.subscribe("familyScopeChange",function(){
    datas = {};
  });
  amplify.subscribe("notificationBullet",function(key,value){
    if(datas[key]!==value){
      datas[key]=value;
      const elements = document.querySelectorAll<HTMLElement>('*[data-notification-key="'+key+'"]');
      elements.forEach(el => {
        el.innerHTML = value;
        if(value){
          Html.fadeIn(el);
        }else{
          Html.fadeOut(el);
        }
      });
    }
  });
  amplify.subscribe("notificationBulletDelta",function(key,value){
    amplify.publish("notificationBullet",key,datas[key] + value);
  });
  websocket.subscribe('New_Message',function(msg){
    const displayedThread = document.querySelector<HTMLElement>("#thread-pane [data-fw-meta-id='"+msg.push.targetId+"']");
    const threadInList = document.querySelector<HTMLElement>(".fw-thread[data-fw-meta-id='"+msg.push.targetId+"']");

    if(displayedThread){
      amplify.publish("refreshThreadMessages",msg.push.targetId);
    }else if(threadInList){
      const notification = threadInList.querySelector<HTMLElement>('.fw-notification');
      if(notification) Html.fadeIn(notification);
    }else{
      amplify.publish("notificationBulletDelta","imunreadthread",1);
    }
  })

function initDom(obj: HTMLElement){
  const key = obj.getAttribute('data-notification-key');
  if(datas[key]){
    obj.innerHTML = datas[key];
    obj.style.display = '';
  }else{
    obj.innerHTML = datas[key] || '';
    obj.style.display = 'none';
  }
}
function get(key){
  return datas[key];
}

Html.registerWidget('widget/notification-bullet',{initDom})

export {get};